import { styled } from '../../stitches.config';

export const Card = styled('div', {
  'display': 'block',
  'padding': '$7',
  'backgroundColor': '$slate1',
  'borderRadius': '$medium',
  'boxShadow': '0 1px 2px $colors$blackA5',
  'variants': {
    interactive: {
      true: {
        'cursor': 'pointer',
        'transition': 'background .3s',
        '& *': {
          cursor: 'pointer',
        },
        '&:hover, &:focus-visible': {
          backgroundColor: '$slate4',
        },
        '&:active': {
          backgroundColor: '$slate6',
        },
        '& .atom-bg': {
          '&:hover, &:focus-visible': {
            fill: '$slate4',
          },
          '&:active': {
            fill: '$slate6',
          },
        },
      },
    },
  },
  '& .atom-bg': { fill: '$slate3' },
});
